"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixStandardChars = void 0;
function fixStandardChars(text, persianGlyphs) {
    for (var i in persianGlyphs) {
        if (Object.prototype.hasOwnProperty.call(persianGlyphs, i)) {
            text = text.replace(new RegExp("[" + persianGlyphs[i] + "]", "g"), i);
        }
    }
    return text;
}
exports.fixStandardChars = fixStandardChars;
